// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ab412bc7","239":"49bb2281","732":"34e2b951"}[chunkId] + ".chunk.js";
};